import React from "react"
import ZdqConnectorSetup from "../../components/ZdqConnectorSetup"
import { GOOGLE_CLOUD_STORAGE } from "../../Constants"

function ZdqGoogleCloudStorageConnector() {
    return <ZdqConnectorSetup vendor={GOOGLE_CLOUD_STORAGE}></ZdqConnectorSetup>
}

export default ZdqGoogleCloudStorageConnector 